module.exports = __webpack_public_path__ + "5a69f1d2d0aeb4e03ab7254469e2f8ab.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/dow3_logo.png
// module id = 258
// module chunks = 0